// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"3ea9716b","218":"b1e30c57","237":"2afd91a5","264":"db7b486f","362":"3a86afd4","394":"719cbf68","416":"f3ceb1f9","425":"2ff9dd03","638":"58c3839d","682":"d4cda15c","906":"b55e1787","993":"1329ab29"}[chunkId] + ".chunk.js";
};